import { AnswerFormatter } from '@classes/AnswerFormatter';
import { SkeletonButton } from '@ui/buttons/SkeletonButton';
import { QueryControllerContext } from '@/contexts/QueryControllerContext';

import { ResultContext } from '@/contexts/ResultContext';
import { Body5, Container } from '@ui';
import React from 'react';
import styled from 'styled-components';

const answerFormatter = new AnswerFormatter();

const FollowUpQuestionWrapper = styled.div`
  padding: 0 16px 16px 16px;
  width: 100%;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const AskQuestionButtonWrapper = styled.div`
  padding: 0 0 0 12px;

  button {
    padding: 4px 16px 6px 16px !important;
  }
`;

function FollowUpQuestion({ followUpQuestion }) {
  const { getFollowUpQuestionForCurrentResult } = React.useContext(QueryControllerContext);

  const followUpQuestionText = answerFormatter.removeBoldMarkdown(
    answerFormatter.removeNumericOrderFromString(followUpQuestion)
  );

  const hc = () => {
    getFollowUpQuestionForCurrentResult(followUpQuestionText);
  };

  return (
    <li>
      <FollowUpQuestionWrapper>
        <Body5>{followUpQuestionText}</Body5>
        <AskQuestionButtonWrapper>
          <SkeletonButton onClick={hc}>Ask</SkeletonButton>
        </AskQuestionButtonWrapper>
      </FollowUpQuestionWrapper>
    </li>
  );
}

export const Followup = () => {
  const { answer } = React.useContext(ResultContext);
  const followUpQuestions = answerFormatter.parseFollowUpQuestions(answer);
  if (followUpQuestions.length === 0 || !answer) {
    return null;
  }
  return (
    <Container top={16}>
      <Container bottom={16}>
        <Body5 bold>Follow Up Questions:</Body5>
      </Container>
      <Body5>
        <ol>
          {followUpQuestions.map((q) => (
            <FollowUpQuestion key={q} followUpQuestion={q} />
          ))}
        </ol>
      </Body5>
    </Container>
  );
};
